
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleManufacturerList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/manufacturer/list${queryString}`
    );
}

export async function consoleManufacturerGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/manufacturer/${item_id}/show`
    );
}

export async function consoleManufacturerCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/manufacturer/create`,
        payload
    );
}

export async function consoleManufacturerPatch(
    item_id: string,
    payload: Partial<any>
) {
    return await clientAxios.patch(
        `admin/console/manufacturer/${item_id}/patch`,
        { payload }
    );
}

export async function consoleManufacturerDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/manufacturer/${item_id}/delete`,
    );
}
